import React from 'react';

function IconPreviewPause() {
  return (
    <svg width="9" height="12" viewBox="0 0 9 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="3" height="12" fill="white"/>
      <rect x="5.24951" width="3" height="12" fill="white"/>
    </svg>
  )
}

export default IconPreviewPause;
